<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <ModalCancelMulctBreakdown
      :dialog="showModalCancelMulctBreakdown"
      @disagree="showModalCancelMulctBreakdown = false"
      @agree="cancelMulctBreakdown"
    ></ModalCancelMulctBreakdown>

    <ModalMulct
      :showModal="modalMulct"
      @btnNao="modalMulct = false"
      @btnSim="cadastroEfetuado"
    />

    <ModalCobrancaTransacaoNaoAutorizada
      :transacao="transaction"
      :showModal="showModalCobranca"
      @btnNao="showModalCobranca = false"
      @btnSim="cobrarTransacao"
    />

    <ModalCheck
      :showModal="dialogConfirmation"
      :msgConfirmation="'concluir a multa?'"
      :command="command"
      @btnNao="dialogConfirmation = false"
      @btnSim="btnSim(command)"
    />

    <ModalFinishTransaction
      :transacao="transaction"
      :showModal="showModalFinishTransaction"
      @btnNao="showModalFinishTransaction = false"
      @btnSim="finishTransaction"
    />

    <v-dialog v-model="showDescription" width="450px">
      <v-card>
        <v-card-text style="padding: 16px">
          {{
            transaction.description ? transaction.description : 'Sem descrição'
          }}
        </v-card-text>
        <v-card-actions class="text-center align-center">
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" @click="showDescription = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Multas e Avarias"
          buttonText="Nova multa"
          :buttonFunction="openMulctModal"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <download-excel
                  :data="data"
                  :fields="json_fields"
                  name="multas.xls"
                >
                  <v-btn
                    :disabled="data.length > 0 ? false : true"
                    block
                    color="success"
                    class="mt-4 white--text"
                  >
                    Exportar
                    <v-icon right>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          class="elevation-1 mt-2"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:[`item.vehicle_request_id`]="{ item }">
            <td>
              {{item.vehicle_request_id}}
              <v-icon small @click="openRequestDetails(item.vehicle_request_id)" color="info">
                open_in_new
              </v-icon>
            </td>
          </template>
          <template v-slot:[`item.total_value_charged`]="{ item }">
            <td>R$ {{ item.total_value_charged | formatPrice }}</td>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <td>{{ item.type | formatType }}</td>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <td>{{ item.created_at | formatData }}</td>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <td>{{ item.status | formatStatus }}</td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <ActionButton
              message="Mostrar descrição"
              icon="search"
              color="info"
              @onclick="openModalShowDescription(item)"
            />
            <ActionButton
              message="Cobrar multa"
              icon="credit_card"
              color="warning"
              @onclick="openModalChargeMulct(item)"
            />
            <ActionButton
              message="Cancelar multa"
              icon="delete"
              color="error"
              @onclick="openModalCancelMulctBreakdown(item)"
            />
            <ActionButton
              message="Concluir multa"
              icon="done"
              color="success"
              @onclick="openModalFinishTransaction(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TransactionController from '../../controllers/TransactionController';
import ModalMulct from '../shared/ModalMulct.vue';
import ModalCancelMulctBreakdown from '../shared/ModalCancelMulctBreakdown.vue';
import ModalCobrancaTransacaoNaoAutorizada from '../shared/ModalCobrancaTransacaoNaoAutorizada.vue';
import ModalCheck from '../shared/ModalCheck.vue';
import ModalFinishTransaction from '../shared/ModalFinishTransaction.vue';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import NumberHelper from './../../helpers/NumberHelper';
import moment from 'moment';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';

export default {
  components: {
    ActionButton,
    ModalMulct,
    ModalCancelMulctBreakdown,
    ModalCobrancaTransacaoNaoAutorizada,
    ModalCheck,
    ModalFinishTransaction,
    TitleWithButton,
  },
  created() {
    this.getMulcts();
  },
  data() {
    return {
      transactionController: new TransactionController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      command: null,
      data: [],
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'ID Reserva', value: 'vehicle_request_id' },
        { text: 'Tipo', value: 'type' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'CPF', value: 'user.cpf' },
        { text: 'Valor total', value: 'total_value_charged' },
        { text: 'Data de criação', value: 'created_at' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      json_fields: {
        Transaction_id: 'id',
        Reserva_id: 'vehicle_request_id',
        Tipo: {
          field: 'type',
          callback: value => {
            return this.formatType(value);
          },
        },
        Usuário: 'user.name',
        'Valor total': {
          field: 'total_value_charged',
          callback: value => {
            return this.formatPrice(value);
          },
        },
        'Data de cobrança': {
          field: 'created_at',
          callback: value => {
            return this.formatData(value);
          },
        },
        Status: {
          field: 'status',
          callback: value => {
            return this.formatStatus(value);
          },
        },
      },
      modalMulct: false,
      transaction: {},
      transactionId: null,
      showModalCobranca: false,
      showModalCancelMulctBreakdown: false,
      dialogConfirmation: false,
      showModalFinishTransaction: false,
      showDescription: false,
    };
  },
  methods: {
    getMulcts() {
      this.transactionController.getMulctsAndBreakdownsPending().then(
        res => {
          this.data = res;
        },
        error => console.log(error)
      );
    },
    openRequestDetails(vehicleRequestId) {
      let routeData = this.$router.resolve(
        '/tcs/reserva/' + vehicleRequestId
      );
      window.open(routeData.href, '_blank');
    },
    openMulctModal() {
      this.modalMulct = true;
    },
    cadastroEfetuado() {
      this.data = [];
      this.getMulcts();
      this.modalMulct = false;
    },
    openModalShowDescription(item) {
      this.transaction = item;
      this.showDescription = true;
    },
    openModalChargeMulct(item) {
      this.transaction = item;
      this.showModalCobranca = true;
    },
    openModalCancelMulctBreakdown(item) {
      this.transactionId = item.id;
      this.showModalCancelMulctBreakdown = true;
    },
    openModalFinishTransaction(item) {
      this.transaction = item;
      this.showModalFinishTransaction = true;
    },
    cancelMulctBreakdown(value) {
      this.transactionController
        .cancelMulctBreakdown(this.transactionId, value.motivo, value.password)
        .then(res => {
          debugger
          if(res.ok) {
            this.$awn.success('Cobrança cancelada com sucesso!');
            this.data = [];
            this.getMulcts();
            this.showModalCancelMulctBreakdown = false;
          } else {
            this.$awn.alert(res.message);
          }
        })
        .catch(error => {
          this.$awn.alert(error.data.message);
        });
    },
    cobrarTransacao(value) {
      this.blockScreen = true;
      this.transactionController
        .captureTransaction({
          id: this.transaction.id,
          credit_card_id: value.creditCardId,
          installments: value.installments,
        })
        .then(res => {
          this.$awn.success('Cobrança realizada com sucesso!');
          this.data = [];
          this.getMulcts();
          this.showModalCobranca = false;
        })
        .catch(error => {
          this.$awn.alert(error.data.message);
        })
        .finally(() => {
          this.blockScreen = false;
        });
    },
    closeTransaction(transaction) {
      this.transaction = transaction;
      this.command = 'finishTransaction';
      this.dialogConfirmation = true;
    },
    finishTransaction(motivo) {
      this.blockScreen = true;
      this.transactionController
        .finishMulct({
          transaction_id: this.transaction.id,
          payment_observation: motivo,
        })
        .then(res => {
          this.$awn.success('Multa finalizada com sucesso!');
          this.data = [];
          this.getMulcts();
          this.showModalFinishTransaction = false;
        })
        .catch(error => {
          this.$awn.alert(error.data.message);
        })
        .finally(() => {
          this.blockScreen = false;
        });
    },
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },
    formatData(value) {
      return moment(value).format('DD[/]MM[/]YYYY HH:mm');
    },
    formatStatus(value) {
      return value == 'pending' ? 'Pendente' : 'Não autorizado';
    },
    formatType(value) {
      return value == 'mulct' ? 'Multa' : 'Avária';
    },
  },
  filters: {
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },
    formatData(value) {
      return moment(value).format('DD[/]MM[/]YYYY HH:mm');
    },
    formatStatus(value) {
      return value == 'pending' ? 'Pendente' : 'Não autorizado';
    },
    formatType(value) {
      return value == 'mulct' ? 'Multa' : 'Avária';
    },
  },
};
</script>
<style lang="scss">
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.new-car-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
.v-input--checkbox > .v-input__control > .v-input__slot > label {
  padding-top: 10px;
}
td.layout {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}

.open-button {
  color: var(--primary-color);
  &:hover {
    color: var(--green-color-hover);
  }
}

.close-button {
  color: var(--red-color);
  &:hover {
    color: var(--red-color-hover);
  }
}

.car-open-buttons:hover {
  cursor: pointer;
}
</style>
